import { DASHBOARD_LINK } from '@components/Router/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

export const useGetDashboardUrl = () => {
  const isEmbed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const teamId = useSelector(migrationProjectSelector.getProjectTeamId)

  if (isEmbed && projectId) {
    return `/${projectId}`
  }

  if (teamId) {
    return `${DASHBOARD_LINK}/${teamId}`
  }

  return `${DASHBOARD_LINK}/${PERSONAL_WORKSPACE_ID}`
}
